import { useQuery } from '@apollo/react-hooks'

import remoteStringsQuery from './remoteStringsQuery.gql'
import { getDisplayString } from '.'

type RemoteStringsResp = {
  remoteStrings: JSON
}

export type getRemoteStringParams = {
  key: string
  variables?: string[]
  color?: string
}

export type getRemoteStringFunction = (params: getRemoteStringParams) => string

export const useRemoteStrings = () => {
  const { data, loading: isLoadingRemoteStrings } = useQuery<RemoteStringsResp>(remoteStringsQuery)

  const getRemoteString = ({ key, variables, color }: getRemoteStringParams) => {
    const remoteString = getDisplayString({
      strings: data?.remoteStrings,
      keys: [key],
      variables,
      variableColor: color,
    })

    return remoteString
  }

  return {
    isLoadingRemoteStrings,
    getRemoteString,
  }
}
